import * as React from "react";
import {ReactElement, useEffect, useState} from "react";
import {Button, Card, Col, Form, Row} from "react-bootstrap";
import {useAppSelector} from "../../store/hooks";
import {api} from "../../utils/axios";
import {useNavigate} from "react-router-dom";
import {useMediaQuery} from "react-responsive";
import {useDispatch} from "react-redux";
import {updateSession} from "../../utils/session";
import '../authentication/styles/verification.css';
import back_arrow from "../../images/back_arrow.png";

const Verification = (): ReactElement => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loginUserInfo = useAppSelector(({ auth }) => auth.loginUserInfo);
  const isAuthenticated = useAppSelector(({ auth }) => auth.isAuthenticated); // ✅
  const isMobileScreen = useMediaQuery({ query: "(max-width: 400px)" });
  const [isNewOtp, setNewOtp] = useState(false);
  const [enableLoginButton, setEnableLoginButton] = useState(false);
   const isDesktopOrLaptop = useMediaQuery({ query: "(min-width: 768px)" });

  const [code, setCode] = useState<string[]>(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(30);
  const [isInvalidOTP, setIsInvalidOTP] = useState(false);
  const [otpMethod, setOtpMethod] = useState<"email" | "SMS">("email");

  // ⏱ Start countdown timer
  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);
    useEffect(() => {
        const allFilled = code.every((digit) => digit.trim() !== "");
        setEnableLoginButton(allFilled);
    }, [code]);

  // 🔐 Determine auth method & redirect if already verified
  useEffect(() => {
    setOtpMethod(loginUserInfo?.email ? "email" : "SMS");

    if (isAuthenticated) {
      navigate("/dashboard");
    }
  }, [loginUserInfo, isAuthenticated, navigate]);

  const handleInputChange = (index: number, value: string) => {
    setIsInvalidOTP(false);
    setNewOtp(false);
    if (/^\d?$/.test(value)) {
      const newCode = [...code];
      newCode[index] = value;
      setCode(newCode);

      if (value !== "" && index < 5) {
        document.getElementById(`code-${index + 1}`)?.focus();
      }

      // if (newCode.every((c) => c !== "")) {
      //   verifyToken(newCode.join(""));
      // }
    }
  };

  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (e.key === "Backspace" && !code[index] && index > 0) {
      document.getElementById(`code-${index - 1}`)?.focus();
    }
    if (e.key === "Enter") {
      const allFilled = code.every((digit) => digit !== "");
      if (allFilled) {
        verifyToken(code.join(""))
      }
    }
  };

  const handlePaste = async (index: number, e: React.ClipboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    e.preventDefault();
    setIsInvalidOTP(false);
    setNewOtp(false);
    const pasted = await navigator.clipboard.readText();
    if (/^\d{6}$/.test(pasted)) {
      const newCode = [...code];
      pasted.split("").forEach((d, i) => {
        if (index + i < 6) newCode[index + i] = d;
      });
      setCode(newCode);

      // if (newCode.every((c) => c !== "")) {
      //   verifyToken(newCode.join(""));
      // }
    }
  };

  const verifyToken = async (otp: string) => {
    try {
      const payload = {
        email: loginUserInfo.email || "",
        mobile: loginUserInfo.mobile || "",
        otp,
      };

      const res = await api.post("/authentication/verify-user", payload);
      if (res.status === 200) {
        await updateSession(dispatch)
        navigate("/dashboard");
      }
    } catch {
      setIsInvalidOTP(true);
      setNewOtp(false);
    }
  };

  const resendOTP = async () => {
    setTimer(30);
    setIsInvalidOTP(false);
    setNewOtp(false);
    setCode(["", "", "", "", "", ""]);

    const payload = {
      email: loginUserInfo?.email || "",
      mobile: loginUserInfo?.mobile || "",
    };

    try {
      await api.post("/authentication/authentication-user", payload);
    } catch {
      console.log("Auth error: ", payload);
    }
  };
  const resetOTPForm = () => {
    setTimer(30);
    setCode(["", "", "", "", "", ""]);
    setIsInvalidOTP(false);
    setNewOtp(false);
    setEnableLoginButton(false);
    navigate('/login')
  };
  const isPhoneNumberEnter = useAppSelector(({ search }) => search.isPhoneNumberEnter);

  const formatPhoneNumber = (value: string): string => {
    if (isNaN(Number(value.replace("-", "")))) return value;
    const cleaned = value.replace(/\D/g, "");

    if (cleaned.length > 6) {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(
        6
      )}`;
    } else if (cleaned.length > 3) {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
    }
    return cleaned;
  };

  return (
    <div className="d-flex text-center justify-content-center flex-column">
    <div className="conciergeLogin-verify">
      <div className="back-button" onClick={resetOTPForm}>
        <div style={{ display: "flex", gap: "10px", alignItems: "center" , fontWeight: 600}}>
          <img src={back_arrow} alt="Back" className="back-arrow" />
          Back
        </div>
      </div>
      <Card className="shadow-sm p-4" style={{ width: isDesktopOrLaptop ? "26.125rem" : "23.125rem" }}>
        <Card.Body>
          <Card.Title className="text-center" style={{ marginBottom: "36px", fontSize:  isDesktopOrLaptop ? "17px" : "15px"  }}>
            <div style={{ color: "#0A4DB2", fontWeight: 600 }}>
              Please enter verification code sent to
            </div>
            <div style={{ color: "#178188" }}>{loginUserInfo?.email || formatPhoneNumber(loginUserInfo?.mobile)}</div>
          </Card.Title>
          <Row className="mb-3 justify-content-center gx-1">
            {code.map((digit, index) => (
              <Col key={index}>
                <Form.Control
                  id={`code-${index}`}
                  type="text"
                  maxLength={1}
                  value={digit}
                  className="text-center"
                  autoFocus={index === 0}
                  onChange={(e) => handleInputChange(index, e.target.value)}
                  onPaste={(e) => handlePaste(index, e)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  style={{ minWidth: "15px", fontSize: "1.85rem" }}
                />
              </Col>
            ))}
          </Row>

          {/* {isInvalidOTP && (
              <div className="text-center invalidOTP text-danger fw-semibold">Invalid OTP.</div>
          )} */}

          {/* <p className="text-center text-muted">
            We sent an {otpMethod} with the code to{" "}
            <strong>{loginUserInfo?.email || loginUserInfo?.mobile}</strong>
          </p> */}
          <div  className="text-center invalidOTP" style={{visibility: isInvalidOTP ? 'visible': 'hidden'}}> Invalid one-time password.</div> 
          {console.log(isPhoneNumberEnter,'kkk')}
          {isNewOtp && <div className="text-center resendOTP" style={{ fontWeight: 'bold', fontSize: isDesktopOrLaptop ? '0.9rem': '0.7rem' }}>{`A new one-time code was sent to your ${isPhoneNumberEnter ? 'phone': 'email'}.`}</div>}
          <button
            className={`${enableLoginButton ? 'button-container' : 'white-button'}  w-100`}
            disabled={!enableLoginButton}
            style={{ marginTop: "20px", height:'3rem' }}
            onClick={() => verifyToken(code.join(""))}
          >
            {"Login"}
          </button>
          <div className="mt-2 agree-terms-and-condition"> By clicking Login, I agree to the SelectDr Terms & Conditions and Privacy Policy.</div>
          <button
            className="blue-button w-100"
            style={{ marginTop: "20px", fontWeight: 'bold', height:'3rem' }}
            onClick={() => {
              resendOTP();
              setNewOtp(true);
              setIsInvalidOTP(false);
            }}
          >
            Resend code
          </button>
        </Card.Body>
      </Card>
    </div>
  </div>
  );
};

export default Verification;
